export default __webpack_public_path__ + "static/media/10.cf63fb45.png";